module.exports = __webpack_public_path__ + "static/img/clock.94975b4a.svg";